import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getAllEvents } from '../config/events';

const EventsListPage = () => {
  const events = getAllEvents().sort((a, b) => a.priority - b.priority);
  
  const isPastEvent = (eventDate) => {
    return new Date(eventDate) < new Date();
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <Container className="py-5" style={{ flex: 1 }}>
        <Row className="text-center mb-5">
          <Col>
            <h1 className="display-4 fw-bold">Our Events</h1>
            <p className="lead">Join us for these amazing faith-based experiences</p>
          </Col>
        </Row>
        <Row>
          {events.map((event, index) => (
            <Col md={6} key={event.id} className="mb-4">
              <Card 
                className={`h-100 shadow animate-card ${isPastEvent(event.eventDate) ? 'border-secondary' : ''}`}
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <Card.Body className="text-center p-4">
                  {isPastEvent(event.eventDate) && (
                    <div className="badge bg-secondary mb-2">Past Event</div>
                  )}
                  <h3 className="fw-bold mb-2">{event.title}</h3>
                  <h5 className="text-muted mb-3">{event.subtitle}</h5>
                  <p className="mb-2"><strong>Dates:</strong> {event.dates}</p>
                  <p className="mb-4"><strong>Location:</strong> {event.location}</p>
                  <Button 
                    as={Link} 
                    to={`/event/${event.id}`}
                    variant={isPastEvent(event.eventDate) ? 'outline-secondary' : 'primary'}
                    size="lg"
                    className="fw-bold"
                  >
                    {isPastEvent(event.eventDate) ? 'View Details' : 'Learn More'}
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default EventsListPage;